"use client";
import { AuthContext } from "@/app/(public)/drawer";
import { useBettor } from "@/utils/providers/bettor";
import Link from "next/link";
import React, { useContext } from "react";

export default function CreateAnAccount() {
  const { bettor } = useBettor();
  const { setAuth } = useContext(AuthContext);
  if (bettor) return null;


  return (
    <>
      <Link
        target="_blank"
        href="/?auth=register"
      >
        <picture>
          <source
            srcSet="/images/cta-create-an-account.webp"
            media="(max-width: 767px)"
          />
          <img
            src="/images/cta-create-an-account.webp"
            alt="Create a Moneyline Account"
            className="w-full sm:object-cover"
          />
        </picture>
      </Link>
    </>
  );
}
